import Shuffle from 'shufflejs';

/**
 * Extends the Shuffle class
 */
class CustomShuffle extends Shuffle {
  /**
   * Return an array of Point instances representing the future positions of
   * each item.
   * @param {ShuffleItem[]} items Array of sorted shuffle items.
   * @returns {Point[]}
   * @private
   */
  _getNextPositions(items) {
    this.indexOffset = 0;

    return items.map((item, index) =>
      // eslint-disable-next-line
      this._getItemPosition(CustomShuffle.getSize(item.element, true), index)
    );
  }

  /**
   * Determine the location of the next item, based on its size.
   * @param {{width: number, height: number}} itemSize Object with width and height.
   * @param {number} index Index of the item.
   * @returns {Point}
   * @private
   */
  _getItemPosition(itemSize, index) {
    if (itemSize.width > this.colWidth) {
      const offset = this.cols - (index + (this.indexOffset % this.cols));
      this.indexOffset += offset;
    }

    const actualIndex = index + this.indexOffset;

    if (actualIndex % this.cols === 0) {
      this.positions.fill(Math.max(...this.positions));
    }

    const x = (actualIndex % this.cols) * itemSize.width;
    const y = this.positions[actualIndex % this.cols];

    this.positions[actualIndex % this.cols] += itemSize.height;

    if (itemSize.width > this.colWidth) {
      this.positions.fill(Math.max(...this.positions));
      this.indexOffset += -1;
    }

    return { x, y };
  }
}

export default CustomShuffle;
